var React = require('react');

function Media (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16,14.2V1.8c0-1-0.8-1.8-1.8-1.8H1.8C0.8,0,0,0.8,0,1.8v12.4c0,1,0.8,1.8,1.8,1.8h12.4C15.2,16,16,15.2,16,14.2z M4.9,9.3\n\tL7.1,12l3.1-4l4,5.3H1.8L4.9,9.3z","fill":"currentColor"}));
}

Media.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Media;

Media.default = Media;
